import { Group } from './../../models/models2/group';
import { GroupLicenseService } from './../../services/group-license.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { LanguageService } from 'src/app/services/language-service';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';

@Component({
  selector: 'app-group-license',
  templateUrl: './group-license.component.html',
  styleUrls: ['./group-license.component.scss'],
})
export class GroupLicenseComponent implements OnInit {
  @ViewChild('groupLicensePopup') private groupLicensePopup!: TemplateRef<any>;
  domLayout = 'autoHeight';

  spinnerText: string = '';
  operator: any;
  userList: any = [];
  breadcrumList!: any;
  permisson!: any;
  IsWrite: boolean = false;
  IsAccess!: any;
  HeaderForm!: FormGroup;

  GroupList: any = [];
  GroupTempList: any = [];
  tDate: any;
  opratorList: any;
  pageId: any;
  userLicenseForm: FormGroup;
  moduleTempList: any = [];
  popupColumnDefs: any = [];
  moduleId: any;

  frameworkComponents: any;
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;

  gridOptions: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  user: string;
  popupRowData: any;
  moduleList: any = [];
  selectedModule: any;
  moduleName: any;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private cilMasterService: CILMasterService,
    private enterpriseGroupService: EnterPriseGroupService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private userManagementService: UserManagementService,
    private managerExecutionService: ManagerExecutionService,
    private GroupLicenseService: GroupLicenseService,
    private languageService: LanguageService
  ) {   
    this.frameworkComponents = {
      buttonRendererView: ButtonViewRendererComponent
    };
  }

  ngOnInit(): void {
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
    this.getGroups();
    this.HeaderForm = this.fb.group({
      group: ['', Validators.required],
    });

    this.getUserList();
    this.GetBreadcrumList();
    this.GetMenuAccess();
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
        this.columnDefs = [
          {
            headerName: 'Module Name',
            field: 'ModuleName',
            
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'Total No. Of License',
            field: 'NoOfLicenses',
            
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'Licenses used',
            field: 'LicensesConsumed',
            
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'Remaining',
            field: 'RemainingLicense',
            
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'Details',
            field: 'Details',
            cellRenderer: 'buttonRendererView',
            cellRendererParams: {
              onClick: this.getAllModules.bind(this),
              label: 'view',
            },
            maxWidth: 85,
            minWidth: 50,
            cellStyle: { textAlign: 'center', padding: 0 },
            // hide: !this.IsWrite,
            suppressMenu: true,
          },
        ];
    
        this.popupColumnDefs = [
          {
            headerName: 'Module Name',
            field: 'ModuleName',
            
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'User Name',
            field: 'EmployeeName',
            
            filter: 'agTextColumnFilter',
          },
        ];
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    this.managerExecutionService.getUserList().subscribe(
      (res: any) => {
        this.spinner.hide();
        this.userList = res.UserList;
        // this.getOperatorData();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.userManagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  getGroups() {
    const key = {
      UserId: '',
    };
    this.cilMasterService.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.dropDownList;
        this.GroupTempList = data.dropDownList;
        if (this.GroupTempList && this.GroupTempList.length) {
          this.HeaderForm.get('group')?.setValue(this.GroupList[0].id);
          this.filterData();
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  onGroupKey(value: any) {
    this.GroupList = this.searchGroupKey(value.value);
  }

  searchGroupKey(value: string) {
    let filter = value;
    return this.GroupTempList.filter((grp: any) => {
      let lowerCase = grp.name.toLocaleLowerCase();
      return grp.name.startsWith(filter) || lowerCase.startsWith(filter);
    });
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  getDetailsForPopup() {
    const data = {
      EgId: this.HeaderForm.value.group,
      ModuleId: this.moduleId,
    };
    this.spinner.show();

    this.GroupLicenseService.getDetailsForPopup(data).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (res.data) {
          this.popupRowData = res.data;
        }
        let dialogRef = this.dialog.open(this.groupLicensePopup, {
          minWidth: '50%',
          minHeight: '50%',
        });
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err.ErrorMessage, 'Error');
      }
    );
  }

  filterData() {
    const data = { EgId: this.HeaderForm.value.group };
    this.GroupLicenseService.filterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.data) {
          this.rowData = res.data;
          this.rowData.map((data: any) => {
            data.Details = 'View';
          });
        }
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err.ErrorMessage, 'Error');
      }
    );
  }
  cellClicked(params: any): void {
    const col = params.colDef.field;
    if (col == 'Details') {
      this.moduleName = params.data.ModuleName;
      this.moduleId = '';
      this.getAllModules(params);
    }
  }
  getAllModules(params: any): void {
    this.moduleName = params.data.ModuleName;
    this.moduleId = '';
    this.languageService.getAllModule().subscribe(
      (data: any) => {
        this.moduleList = data.moduleList;
        const selectedModule = this.moduleList.find(
          (values: any) => values.moduleName == this.moduleName
        );
        this.moduleId = selectedModule.moduleId;
        this.getDetailsForPopup();
      },
      (error: any) => {
        this.toaster.error('error', error.message, { timeOut: 3000 });
      }
    );
  }
  a;
}
